module.exports = __webpack_public_path__ + "img/bild-e.0dbc0a58.png";